// extracted by mini-css-extract-plugin
module.exports = {"modal_content":"ModalDaily_modal_content__1AsBE"};